<template>
    <Maintable />
</template>

<script>
import Sidebar from '../components/Sidebar.vue';
import Maintable from '../views/Maintable';

export default {
    components: { Sidebar, Maintable  }
};
</script>

<style scoped>
    .dash {
        display: flex;
    }
</style>
